import { gql } from "@apollo/client"

export const LIKE_TEAM_ACTION_QUERY = gql`
    query LikeTeamActionQuery($pallet: String!) {
        group(slug: $pallet) {
            id
            activeMember {
                id
                applicationStatusEnum
            }
        }
    }
`
